// GENERATED by tools/check-modules.js — do not edit. Run `node tools/check-modules.js` to refresh.
import { registerModule, type Manifest } from '@tradeview/core';
import analyticsManifest from '../../../modules/analytics/manifest.json';
import bidsManifest from '../../../modules/bids/manifest.json';
import billingManifest from '../../../modules/billing/manifest.json';
import channelManifest from '../../../modules/channel/manifest.json';
import controlsManifest from '../../../modules/controls/manifest.json';
import costingManifest from '../../../modules/costing/manifest.json';
import drawingsManifest from '../../../modules/drawings/manifest.json';
import fieldDayManifest from '../../../modules/field-day/manifest.json';
import fieldRecordsManifest from '../../../modules/field-records/manifest.json';
import mailManifest from '../../../modules/mail/manifest.json';
import materialsManifest from '../../../modules/materials/manifest.json';
import planManifest from '../../../modules/plan/manifest.json';
import procurementManifest from '../../../modules/procurement/manifest.json';
import punchManifest from '../../../modules/punch/manifest.json';
import serviceManifest from '../../../modules/service/manifest.json';
import timeManifest from '../../../modules/time/manifest.json';
import warehouseManifest from '../../../modules/warehouse/manifest.json';

// JSON imports are typed loosely; registerModule re-validates every manifest with the zod schema at startup.
function screenOf(ns: unknown, name: string, id: string) {
  const x = ns as Record<string, unknown>;
  const c = x[name] ?? x.default;
  if (typeof c !== 'function') throw new Error(`Module ${id} does not export a screen named ${name}`);
  return { default: c as React.ComponentType };
}
export function registerAllModules() {
  registerModule({
    manifest: analyticsManifest as unknown as Manifest,
    screens: {
      "AnalyticsHomeScreen": () => import('../../../modules/analytics/src/index').then(x => screenOf(x, "AnalyticsHomeScreen", "analytics")),
      "JobHealthScreen": () => import('../../../modules/analytics/src/index').then(x => screenOf(x, "JobHealthScreen", "analytics")),
      "MoneyScreen": () => import('../../../modules/analytics/src/index').then(x => screenOf(x, "MoneyScreen", "analytics")),
      "LaborScreen": () => import('../../../modules/analytics/src/index').then(x => screenOf(x, "LaborScreen", "analytics")),
      "BoardPackScreen": () => import('../../../modules/analytics/src/index').then(x => screenOf(x, "BoardPackScreen", "analytics")),
    },
  });
  registerModule({
    manifest: bidsManifest as unknown as Manifest,
    screens: {
      "PipelineScreen": () => import('../../../modules/bids/src/index').then(x => screenOf(x, "PipelineScreen", "bids")),
      "NewBidScreen": () => import('../../../modules/bids/src/index').then(x => screenOf(x, "NewBidScreen", "bids")),
      "BidScreen": () => import('../../../modules/bids/src/index').then(x => screenOf(x, "BidScreen", "bids")),
      "GcsScreen": () => import('../../../modules/bids/src/index').then(x => screenOf(x, "GcsScreen", "bids")),
      "BidQuotesScreen": () => import('../../../modules/bids/src/index').then(x => screenOf(x, "BidQuotesScreen", "bids")),
      "ProposalScreen": () => import('../../../modules/bids/src/index').then(x => screenOf(x, "ProposalScreen", "bids")),
      "LostScreen": () => import('../../../modules/bids/src/index').then(x => screenOf(x, "LostScreen", "bids")),
    },
  });
  registerModule({
    manifest: billingManifest as unknown as Manifest,
    screens: {
      "BillingScreen": () => import('../../../modules/billing/src/index').then(x => screenOf(x, "BillingScreen", "billing")),
      "SovScreen": () => import('../../../modules/billing/src/index').then(x => screenOf(x, "SovScreen", "billing")),
      "NewAppScreen": () => import('../../../modules/billing/src/index').then(x => screenOf(x, "NewAppScreen", "billing")),
      "AppScreen": () => import('../../../modules/billing/src/index').then(x => screenOf(x, "AppScreen", "billing")),
      "PeriodScreen": () => import('../../../modules/billing/src/index').then(x => screenOf(x, "PeriodScreen", "billing")),
      "NewWaiverScreen": () => import('../../../modules/billing/src/index').then(x => screenOf(x, "NewWaiverScreen", "billing")),
      "WaiverScreen": () => import('../../../modules/billing/src/index').then(x => screenOf(x, "WaiverScreen", "billing")),
      "ReceivablesScreen": () => import('../../../modules/billing/src/index').then(x => screenOf(x, "ReceivablesScreen", "billing")),
    },
  });
  registerModule({
    manifest: channelManifest as unknown as Manifest,
    screens: {
      "ChannelScreen": () => import('../../../modules/channel/src/index').then(x => screenOf(x, "ChannelScreen", "channel")),
      "ThreadScreen": () => import('../../../modules/channel/src/index').then(x => screenOf(x, "ThreadScreen", "channel")),
    },
  });
  registerModule({
    manifest: controlsManifest as unknown as Manifest,
    screens: {
      "ControlsScreen": () => import('../../../modules/controls/src/index').then(x => screenOf(x, "ControlsScreen", "controls")),
      "RfisScreen": () => import('../../../modules/controls/src/index').then(x => screenOf(x, "RfisScreen", "controls")),
      "NewRfiScreen": () => import('../../../modules/controls/src/index').then(x => screenOf(x, "NewRfiScreen", "controls")),
      "RfiScreen": () => import('../../../modules/controls/src/index').then(x => screenOf(x, "RfiScreen", "controls")),
      "SubmittalsScreen": () => import('../../../modules/controls/src/index').then(x => screenOf(x, "SubmittalsScreen", "controls")),
      "NewSubmittalScreen": () => import('../../../modules/controls/src/index').then(x => screenOf(x, "NewSubmittalScreen", "controls")),
      "SubmittalScreen": () => import('../../../modules/controls/src/index').then(x => screenOf(x, "SubmittalScreen", "controls")),
      "ChangeOrdersScreen": () => import('../../../modules/controls/src/index').then(x => screenOf(x, "ChangeOrdersScreen", "controls")),
      "NewChangeOrderScreen": () => import('../../../modules/controls/src/index').then(x => screenOf(x, "NewChangeOrderScreen", "controls")),
      "ChangeOrderScreen": () => import('../../../modules/controls/src/index').then(x => screenOf(x, "ChangeOrderScreen", "controls")),
      "TmLogEditorScreen": () => import('../../../modules/controls/src/index').then(x => screenOf(x, "TmLogEditorScreen", "controls")),
      "TmLogScreen": () => import('../../../modules/controls/src/index').then(x => screenOf(x, "TmLogScreen", "controls")),
      "AddendaScreen": () => import('../../../modules/controls/src/index').then(x => screenOf(x, "AddendaScreen", "controls")),
    },
  });
  registerModule({
    manifest: costingManifest as unknown as Manifest,
    screens: {
      "CostScreen": () => import('../../../modules/costing/src/index').then(x => screenOf(x, "CostScreen", "costing")),
      "LaborScreen": () => import('../../../modules/costing/src/index').then(x => screenOf(x, "LaborScreen", "costing")),
      "CodeScreen": () => import('../../../modules/costing/src/index').then(x => screenOf(x, "CodeScreen", "costing")),
      "BudgetScreen": () => import('../../../modules/costing/src/index').then(x => screenOf(x, "BudgetScreen", "costing")),
      "RatesScreen": () => import('../../../modules/costing/src/index').then(x => screenOf(x, "RatesScreen", "costing")),
    },
  });
  registerModule({
    manifest: drawingsManifest as unknown as Manifest,
    screens: {
      "DrawingsScreen": () => import('../../../modules/drawings/src/index').then(x => screenOf(x, "DrawingsScreen", "drawings")),
      "AddSheetScreen": () => import('../../../modules/drawings/src/index').then(x => screenOf(x, "AddSheetScreen", "drawings")),
      "SheetScreen": () => import('../../../modules/drawings/src/index').then(x => screenOf(x, "SheetScreen", "drawings")),
    },
  });
  registerModule({
    manifest: fieldDayManifest as unknown as Manifest,
    screens: {
      "ReportsScreen": () => import('../../../modules/field-day/src/index').then(x => screenOf(x, "ReportsScreen", "field-day")),
      "DailyReportScreen": () => import('../../../modules/field-day/src/index').then(x => screenOf(x, "DailyReportScreen", "field-day")),
      "WeeklyReportScreen": () => import('../../../modules/field-day/src/index').then(x => screenOf(x, "WeeklyReportScreen", "field-day")),
      "WeeklyPageScreen": () => import('../../../modules/field-day/src/index').then(x => screenOf(x, "WeeklyPageScreen", "field-day")),
      "ReportScreen": () => import('../../../modules/field-day/src/index').then(x => screenOf(x, "ReportScreen", "field-day")),
    },
  });
  registerModule({
    manifest: fieldRecordsManifest as unknown as Manifest,
    screens: {
      "RecordsScreen": () => import('../../../modules/field-records/src/index').then(x => screenOf(x, "RecordsScreen", "field-records")),
      "NewRecordScreen": () => import('../../../modules/field-records/src/index').then(x => screenOf(x, "NewRecordScreen", "field-records")),
      "ExportScreen": () => import('../../../modules/field-records/src/index').then(x => screenOf(x, "ExportScreen", "field-records")),
      "TopicsScreen": () => import('../../../modules/field-records/src/index').then(x => screenOf(x, "TopicsScreen", "field-records")),
      "RecordScreen": () => import('../../../modules/field-records/src/index').then(x => screenOf(x, "RecordScreen", "field-records")),
    },
  });
  registerModule({
    manifest: mailManifest as unknown as Manifest,
    screens: {
      "MailScreen": () => import('../../../modules/mail/src/index').then(x => screenOf(x, "MailScreen", "mail")),
      "UnfiledScreen": () => import('../../../modules/mail/src/index').then(x => screenOf(x, "UnfiledScreen", "mail")),
      "ComposeScreen": () => import('../../../modules/mail/src/index').then(x => screenOf(x, "ComposeScreen", "mail")),
      "MessageScreen": () => import('../../../modules/mail/src/index').then(x => screenOf(x, "MessageScreen", "mail")),
    },
  });
  registerModule({
    manifest: materialsManifest as unknown as Manifest,
    screens: {
      "MaterialsScreen": () => import('../../../modules/materials/src/index').then(x => screenOf(x, "MaterialsScreen", "materials")),
      "RequestScreen": () => import('../../../modules/materials/src/index').then(x => screenOf(x, "RequestScreen", "materials")),
      "RequisitionScreen": () => import('../../../modules/materials/src/index').then(x => screenOf(x, "RequisitionScreen", "materials")),
      "ToolRequestScreen": () => import('../../../modules/materials/src/index').then(x => screenOf(x, "ToolRequestScreen", "materials")),
      "ToolRequisitionScreen": () => import('../../../modules/materials/src/index').then(x => screenOf(x, "ToolRequisitionScreen", "materials")),
      "RunScreen": () => import('../../../modules/materials/src/index').then(x => screenOf(x, "RunScreen", "materials")),
      "ReceiveScreen": () => import('../../../modules/materials/src/index').then(x => screenOf(x, "ReceiveScreen", "materials")),
      "DeliveryScreen": () => import('../../../modules/materials/src/index').then(x => screenOf(x, "DeliveryScreen", "materials")),
    },
  });
  registerModule({
    manifest: planManifest as unknown as Manifest,
    screens: {
      "PlanScreen": () => import('../../../modules/plan/src/index').then(x => screenOf(x, "PlanScreen", "plan")),
      "PickScreen": () => import('../../../modules/plan/src/index').then(x => screenOf(x, "PickScreen", "plan")),
      "ProjectScreen": () => import('../../../modules/plan/src/index').then(x => screenOf(x, "ProjectScreen", "plan")),
      "TaskScreen": () => import('../../../modules/plan/src/index').then(x => screenOf(x, "TaskScreen", "plan")),
    },
  });
  registerModule({
    manifest: procurementManifest as unknown as Manifest,
    screens: {
      "ProcurementScreen": () => import('../../../modules/procurement/src/index').then(x => screenOf(x, "ProcurementScreen", "procurement")),
      "OrdersScreen": () => import('../../../modules/procurement/src/index').then(x => screenOf(x, "OrdersScreen", "procurement")),
      "NewOrderScreen": () => import('../../../modules/procurement/src/index').then(x => screenOf(x, "NewOrderScreen", "procurement")),
      "OrderScreen": () => import('../../../modules/procurement/src/index').then(x => screenOf(x, "OrderScreen", "procurement")),
      "BillScreen": () => import('../../../modules/procurement/src/index').then(x => screenOf(x, "BillScreen", "procurement")),
      "QuotesScreen": () => import('../../../modules/procurement/src/index').then(x => screenOf(x, "QuotesScreen", "procurement")),
      "PlanScreen": () => import('../../../modules/procurement/src/index').then(x => screenOf(x, "PlanScreen", "procurement")),
      "FulfilmentScreen": () => import('../../../modules/procurement/src/index').then(x => screenOf(x, "FulfilmentScreen", "procurement")),
      "ShelfScreen": () => import('../../../modules/procurement/src/index').then(x => screenOf(x, "ShelfScreen", "procurement")),
      "RunsScreen": () => import('../../../modules/procurement/src/index').then(x => screenOf(x, "RunsScreen", "procurement")),
    },
  });
  registerModule({
    manifest: punchManifest as unknown as Manifest,
    screens: {
      "PunchListScreen": () => import('../../../modules/punch/src/index').then(x => screenOf(x, "PunchListScreen", "punch")),
      "NewPunchScreen": () => import('../../../modules/punch/src/index').then(x => screenOf(x, "NewPunchScreen", "punch")),
      "CloseoutScreen": () => import('../../../modules/punch/src/index').then(x => screenOf(x, "CloseoutScreen", "punch")),
      "PunchItemScreen": () => import('../../../modules/punch/src/index').then(x => screenOf(x, "PunchItemScreen", "punch")),
    },
  });
  registerModule({
    manifest: serviceManifest as unknown as Manifest,
    screens: {
      "ServiceHomeScreen": () => import('../../../modules/service/src/index').then(x => screenOf(x, "ServiceHomeScreen", "service")),
      "NewCallScreen": () => import('../../../modules/service/src/index').then(x => screenOf(x, "NewCallScreen", "service")),
      "WorkOrderScreen": () => import('../../../modules/service/src/index').then(x => screenOf(x, "WorkOrderScreen", "service")),
      "InvoiceScreen": () => import('../../../modules/service/src/index').then(x => screenOf(x, "InvoiceScreen", "service")),
      "InvoicesScreen": () => import('../../../modules/service/src/index').then(x => screenOf(x, "InvoicesScreen", "service")),
      "CustomersScreen": () => import('../../../modules/service/src/index').then(x => screenOf(x, "CustomersScreen", "service")),
      "CustomerScreen": () => import('../../../modules/service/src/index').then(x => screenOf(x, "CustomerScreen", "service")),
      "DispatchScreen": () => import('../../../modules/service/src/index').then(x => screenOf(x, "DispatchScreen", "service")),
      "ServiceSettingsScreen": () => import('../../../modules/service/src/index').then(x => screenOf(x, "ServiceSettingsScreen", "service")),
    },
  });
  registerModule({
    manifest: timeManifest as unknown as Manifest,
    screens: {
      "ClockScreen": () => import('../../../modules/time/src/index').then(x => screenOf(x, "ClockScreen", "time")),
      "MyWeekScreen": () => import('../../../modules/time/src/index').then(x => screenOf(x, "MyWeekScreen", "time")),
      "FixPunchScreen": () => import('../../../modules/time/src/index').then(x => screenOf(x, "FixPunchScreen", "time")),
      "ApproveWeekScreen": () => import('../../../modules/time/src/index').then(x => screenOf(x, "ApproveWeekScreen", "time")),
      "ScheduleScreen": () => import('../../../modules/time/src/index').then(x => screenOf(x, "ScheduleScreen", "time")),
      "LookAheadScreen": () => import('../../../modules/time/src/index').then(x => screenOf(x, "LookAheadScreen", "time")),
    },
  });
  registerModule({
    manifest: warehouseManifest as unknown as Manifest,
    screens: {
      "WarehouseHomeScreen": () => import('../../../modules/warehouse/src/index').then(x => screenOf(x, "WarehouseHomeScreen", "warehouse")),
      "StockScreen": () => import('../../../modules/warehouse/src/index').then(x => screenOf(x, "StockScreen", "warehouse")),
      "StockItemScreen": () => import('../../../modules/warehouse/src/index').then(x => screenOf(x, "StockItemScreen", "warehouse")),
      "PullScreen": () => import('../../../modules/warehouse/src/index').then(x => screenOf(x, "PullScreen", "warehouse")),
      "ToolsScreen": () => import('../../../modules/warehouse/src/index').then(x => screenOf(x, "ToolsScreen", "warehouse")),
      "ToolScreen": () => import('../../../modules/warehouse/src/index').then(x => screenOf(x, "ToolScreen", "warehouse")),
      "ToolRequestsScreen": () => import('../../../modules/warehouse/src/index').then(x => screenOf(x, "ToolRequestsScreen", "warehouse")),
      "MovementLogScreen": () => import('../../../modules/warehouse/src/index').then(x => screenOf(x, "MovementLogScreen", "warehouse")),
      "WarehouseSettingsScreen": () => import('../../../modules/warehouse/src/index').then(x => screenOf(x, "WarehouseSettingsScreen", "warehouse")),
    },
  });
}

export const MODULE_IDS = ["analytics","bids","billing","channel","controls","costing","drawings","field-day","field-records","mail","materials","plan","procurement","punch","service","time","warehouse"] as const;
export const CORE_MODULE_IDS = [] as const;
